import React from 'react';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-16 px-8 text-center" data-id="element-450">
      <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-blue-50 border border-blue-100" data-id="element-451">
        <Icon className="w-6 h-6 text-blue-500" data-id="element-452" />
      </div>
      <h3 className="mb-1 text-base font-semibold text-gray-900" data-id="element-453">{title}</h3>
      <p className="text-sm text-gray-500 max-w-xs" data-id="element-454">{description}</p>
      {action && <div className="mt-5" data-id="element-455">{action}</div>}
    </div>;
}